import { italicMarkPlugin, italicMark } from "./italicMark.js";
import { createMarkHtmlDeserializer } from "../../../baseEditor/CustomMarkPlugin.js";
const withItalic = (editor) => {
  editor.registerMark(italicMarkPlugin);
  editor.htmlDeserializer.registerPlugin(
    createMarkHtmlDeserializer(
      italicMark,
      (el) => ["I", "EM"].includes(el.nodeName),
      (el) => ["italic", "oblique"].includes(el.style.fontWeight)
    )
  );
  return editor;
};
export {
  withItalic
};
//# sourceMappingURL=withItalic.js.map
